// @core/api/endpoints/workflow/get_event_descriptor.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventDescriptorResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get event descriptor
 * Retrieves an event descriptor by event name. Returns payload schema and sample data for the event.
 */
export async function GetEventDescriptor(
  event_name: string,
  options?: RequestOptions
): Promise<EventDescriptorResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/event-descriptors/:event_name`;
  requestPath = requestPath.replace(':event_name', encodeURIComponent(event_name));
  const requestOptions = options;
  return client.get<EventDescriptorResponse>(requestPath, { ...requestOptions });
}
